import {
  afterNextRender,
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  Input, OnChanges,
  OnDestroy, PLATFORM_ID, SimpleChanges,
  ViewChild
} from '@angular/core';
import {isPlatformBrowser, NgClass} from "@angular/common";
import {DomSanitizer} from "@angular/platform-browser";
@Component({
  selector: 'white-label-video-player',
  standalone: true,
  imports: [
    NgClass,
  ],
  templateUrl: './video-player.component.html',
  styleUrl: './video-player.component.scss'
})
export class VideoPlayerComponent implements OnDestroy, OnChanges, AfterViewInit{
  @ViewChild('videoPlayer', { static: false }) videoPlayer!: ElementRef<HTMLVideoElement>;

  @Input() videoUrl: string = '';
  @Input() autoplay: boolean = false;
  @Input() loop: boolean = false;
  @Input() showMuteButton: boolean = true;
  @Input() showPlayButton: boolean = true;

  @Input() isMuted: boolean = true;
  isPlaying: boolean = false;
  needIframe: boolean = false;
  safeVideoUrl: any


  constructor(@Inject(PLATFORM_ID) protected platformId: any,
              private sanitizer: DomSanitizer) {
    afterNextRender(()=>{
        setTimeout(()=>{
          if (this.autoplay && this.videoPlayer) {
            this.videoPlayer.nativeElement.play();
            this.videoPlayer.nativeElement.muted = this.isMuted;
            this.videoPlayer.nativeElement.muted;
          }
        },1000)
        this.isPlaying = true;
    })
  }

  ngAfterViewInit() {
    this.initVideoPlayer();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['videoUrl'] && !changes['videoUrl'].isFirstChange()) {
      this.videoUrl = changes['videoUrl'].currentValue
      // Handle video URL changes
      this.initVideoPlayer();
    }
  }

  private initVideoPlayer(): void {
    if (isPlatformBrowser(this.platformId) && this.videoPlayer) {
      if (this.isMp4Url(this.videoUrl)) {
        this.needIframe = false
        const videoElement = this.videoPlayer.nativeElement;
        if (this.autoplay) {
          videoElement.play().catch((err) => console.error('Autoplay failed:', err));
        }
        videoElement.muted = this.isMuted;
        this.isPlaying = !videoElement.paused;
      }else {
        this.getSafeUrl();
        this.needIframe = true
      }

    }
  }

  getSafeUrl() {
    let url = this.videoUrl;

    // Check if the URL is a standard or short YouTube link and convert it to embed format
    const youtubeRegex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|v\/|user\/.*#\w\/\w\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/;
    const match = url.match(youtubeRegex);

    if (match) {
      const videoId = match[1];
      url = `https://www.youtube.com/embed/${videoId}`;
    }

    // Handle autoplay and mute for YouTube and Vimeo
    if (this.autoplay) {
      const separator = url.includes('?') ? '&' : '?';
      if (url.includes('youtube.com/embed')) {
        url += `${separator}autoplay=1&mute=1`;
      } else if (url.includes('vimeo.com/video')) {
        url += `${separator}autoplay=1`;
      }
    }
    this.safeVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);

  }

  isMp4Url(url: string): boolean {
    return url.endsWith('.mp4') || url.includes('.mp4?');
  }

  toggleMute() {
    this.isMuted = !this.isMuted;
    this.videoPlayer.nativeElement.muted = this.isMuted;
  }

  checkIsPlatformBrowser(){
    return isPlatformBrowser(this.platformId);
  }

  togglePlay() {
    if(isPlatformBrowser(this.platformId)){
      if (this.isPlaying) {
        this.videoPlayer.nativeElement.pause();
      } else {
        this.videoPlayer.nativeElement.play();
      }
      this.isPlaying = !this.isPlaying;
    }

  }

  ngOnDestroy() {
    if(isPlatformBrowser(this.platformId) && this.videoPlayer){
      // Reset the video state
      this.videoPlayer.nativeElement.pause();
      this.videoPlayer.nativeElement.currentTime = 0;
      this.isMuted = true;
      this.isPlaying = false;
    }

  }

  onVideoLoad(videoElement: HTMLVideoElement) {
    if(this.isMuted){
      videoElement.muted = this.isMuted;
    }
  }
}
